import { create } from 'zustand';
import type {
  WorkspaceWorkspaceWriteModel,
  WorkspaceConfigWorkspaceWriteModel
} from '@r/api/generated/client.schemas.ts';

type WorkspaceFormData = WorkspaceWorkspaceWriteModel;

interface WorkspaceFormState {
  workspaces: Record<string, Partial<WorkspaceFormData>>;
  updateFormData: (
    workspaceId: number,
    newData: Partial<WorkspaceFormData>
  ) => Promise<WorkspaceFormData>;
}

// Note: defaultWorkspaceData sera rempli dynamiquement avec les configs réelles
// car nous avons besoin des IDs de config pour construire les IRIs
const defaultWorkspaceData: Partial<WorkspaceFormData> = {
  workspaceConfigs: []
};

export const useWorkspaceFormStore = create<WorkspaceFormState>((set, get) => ({
  workspaces: {},
  updateFormData: async (workspaceId: number, newData: Partial<WorkspaceFormData>) => {
    const { workspaces } = get();
    const currentData = workspaces[workspaceId] || defaultWorkspaceData;
    const updatedData = { ...currentData };

    if (newData.workspaceConfigs) {
      const currentConfigs = currentData.workspaceConfigs || [];

      // Comparer les configs par leur IRI (nouveau format uniquement)
      const updatedConfigs = currentConfigs.map((config) => {
        const newConfig = newData.workspaceConfigs?.find(
          (newConf) => newConf.config === config.config
        );
        return newConfig || config;
      });

      const newConfigs = newData.workspaceConfigs.filter(
        (newConf) => !currentConfigs.some((config) => config.config === newConf.config)
      );

      updatedData.workspaceConfigs = [
        ...updatedConfigs,
        ...newConfigs
      ] as WorkspaceConfigWorkspaceWriteModel[];
    }

    const completeData = {
      ...updatedData,
      ...newData,
      name: newData.name || updatedData.name || '',
      workspaceConfigs: updatedData.workspaceConfigs || []
    } as WorkspaceFormData;

    set((state) => ({
      workspaces: {
        ...state.workspaces,
        [workspaceId]: completeData
      }
    }));

    return completeData;
  }
}));
